"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('unlink', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(23.500000, 24.000000) rotate(-45.000000) translate(-23.500000, -24.000000) translate(16.000000, 1.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M14.8272301,19.056761 L14.8272301,8.05676102 C14.8272301,4.00667285 11.6792322,0.723427686 7.79598008,0.723427686 C3.91272793,0.723427686 0.764730077,4.00667285 0.764730077,8.05676102 L0.764730077,19.056761"
  }), _react.default.createElement("path", {
    d: "M14.8153692,45.9222209 L14.8153692,34.9222209 C14.8153692,30.8721328 11.9589521,27.4911368 7.78411916,27.5888876 C3.60928625,27.6866384 0.752869165,30.8721328 0.752869165,34.9222209 L0.752869165,45.9222209",
    transform: "translate(7.784119, 36.754520) scale(1, -1) translate(-7.784119, -36.754520) "
  }), _react.default.createElement("path", {
    d: "M7.96875,19.3333333 L7.96875,13.8333333"
  }), _react.default.createElement("path", {
    d: "M7.96875,32.1666667 L7.96875,26.6666667"
  }))));
});

exports.default = _default;